var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImageRatio31(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 8,
    viewBox: "0 0 22 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H2a2 2 0 00-2 2v4a2 2 0 002 2h18a2 2 0 002-2V2a2 2 0 00-2-2z",
    fill: "#80B1FF",
    fillRule: "nonzero"
  })));
}

export default "data:image/svg+xml,%3csvg width='22px' height='8px' viewBox='0 0 22 8' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3eimageRatio_16-9%3c/title%3e %3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='imageRatio_16-9' fill='%2380B1FF' fill-rule='nonzero'%3e %3cpath d='M20,0 L2,0 C0.8954305,0 0,0.8954305 0,2 L0,6 C0,7.1045695 0.8954305,8 2,8 L20,8 C21.1045695,8 22,7.1045695 22,6 L22,2 C22,0.8954305 21.1045695,0 20,0 Z' id='Path'%3e%3c/path%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgImageRatio31 as ReactComponent };